<i18n lang="yaml">
en:
  selectel: 'Selectel Ltd.'
  lecense: 'Telematic service license'
  and: 'and'
ru:
  selectel: 'ООО «Селектел»'
  lecense: 'Лицензия на телематические услуги'
  and: 'и'
</i18n>

<template>
  <div class="container">
    <footer-socials class="footer__socials-mobile"></footer-socials>

    <div class="footer__container">
      <div class="footer__contacts">
        <footer-socials class="footer__socials-desktop"></footer-socials>
        <footer-contacts></footer-contacts>
      </div>

      <footer-menu-block
        v-for="(block, index) in menuBlocks"
        :key="index"
        :block="block"
      ></footer-menu-block>

      <div class="footer__copyright-container">
        <p class="footer__copyright">
          © {{ $t('selectel') }}, 2008—{{ currentYear }}
        </p>
        <p class="footer__licenses">
          {{ $t('lecense') }}
          <br>
          <a
            href="https://rkn.gov.ru/communication/register/license/?id=176266"
            rel="noopener noreferrer"
            target="_blank"
          >
            №&nbsp;176266
          </a>
          &nbsp;{{ $t('and') }}&nbsp;
          <a
            href="https://rkn.gov.ru/communication/register/license/?id=176267"
            rel="noopener noreferrer"
            target="_blank"
          >
            №&nbsp;176267
          </a>
        </p>
      </div>

      <img
        v-lazy-load
        class="footer__logo--company"
        :data-src="require('~/assets/images/components/footer/logo.svg?inline').default"
        alt="Selectel"
      >
    </div>
  </div>
</template>

<script>
import FooterSocials from '~/components/footer/FooterSocials'
import FooterContacts from '~/components/footer/FooterContacts'
import FooterMenuBlock from '~/components/footer/FooterMenuBlock'
import {mapGetters} from 'vuex'

const menu = {
  en: [
    {
      id: 'partners',
      title: 'For partners',
      items: [
        {
          title: 'Referral program',
          link: '/about/partners/referral-unlimited/'
        }
      ]
    },
    {
      id: 'careers',
      title: 'Career',
      items: [
        {
          title: 'Work at Selectel',
          link: '/careers/'
        },
        {
          title: 'Jobs',
          link: '/careers/all/'
        },
        {
          title: 'Internships',
          link: '/careers/internships/'
        }
      ]
    },
    {
      id: 'resources',
      title: 'Resources',
      items: [
        {
          title: 'Blog',
          link: 'https://blog.selectel.com/',
          external: true
        },
        {
          title: 'Knowledge Base',
          link: 'https://kb.selectel.com/',
          external: true
        },
        {
          title: 'API documentation',
          link: 'https://developers.selectel.com/',
          external: true
        },
        {
          title: 'Success Stories',
          link: '/success-story/'
        },
        {
          title: 'Useful materials',
          link: '/wp/'
        }
      ]
    },
    {
      id: 'lawyers',
      title: 'Legal',
      items: [
        {
          title: 'Payment Methods',
          link: '/about/payments/individuals-pay/'
        },
        {
          title: 'Documents',
          link: '/about/documents/'
        },
        {
          title: 'Bank details and licenses',
          link: '/about/details/'
        },
        {
          title: 'Tenders and procurement',
          link: '/tenders/'
        }
      ]
    },
    {
      id: 'company',
      title: 'Company',
      items: [
        {
          title: 'About Company',
          link: '/about/company/'
        },
        {
          title: 'Data Centers',
          link: '/about/data-centers/'
        },
        {
          title: 'Conference Hall',
          link: '/about/conference-hall/'
        },
        {
          title: 'Contacts',
          link: '/about/contacts/'
        },
        {
          title: 'Special Offers',
          link: '/promo/'
        },
        {
          title: 'Find a partner',
          link: '/about/partners-offers/'
        },
        {
          title: 'For investors',
          link: '/investors'
        }
      ]
    },
    {
      id: 'news',
      title: 'News and Events',
      items: [
        {
          title: 'News and press releases',
          link: '/about/newsroom/news/'
        },
        {
          title: 'Our press coverage',
          link: '/about/newsroom/press/'
        },
        {
          title: 'Press Materials',
          link: '/about/newsroom/materials/'
        }
      ]
    },
    {
      id: 'techpartners',
      title: 'Technology Partner',
      items: [
        {
          title: 'Intel',
          link: '/about/partners/intel/'
        },
        {
          title: 'Veeam Software',
          link: '/about/partners/veeam/'
        },
        {
          title: 'VMware',
          link: '/about/partners/vmware/'
        }
      ]
    },
    {
      id: 'offices',
      title: 'Offices',
      sections: [
        {
          city: 'Moscow',
          address: '36&nbsp;Berzarina&nbsp;St., building&nbsp;3',
          phone: '+7 (495) 647-79-80',
          formattedPhone: '+74956477980'
        },
        {
          city: 'St. Petersburg',
          address: '21&nbsp;Tsvetochnaya&nbsp;St., lit. A',
          phone: '+7 (800) 555-06-75',
          formattedPhone: '+78005550675'
        },
        {
          city: 'Kiev',
          address: 'Prospect Peremohy, 131, room&nbsp;3'
        }
      ]
    }
  ],
  ru: [
    {
      id: 'partners',
      title: 'Партнерам',
      items: [
        {
          title: 'Реферальная программа',
          link: '/about/partners/referral-unlimited/'
        }
      ]
    },
    {
      id: 'careers',
      title: 'Карьера',
      items: [
        {
          title: 'Работа в Selectel',
          link: '/careers/'
        },
        {
          title: 'Актуальные вакансии',
          link: '/careers/all/'
        },
        {
          title: 'Стажировка',
          link: '/careers/internships/'
        }
      ]
    },
    {
      id: 'resources',
      title: 'Ресурсы',
      items: [
        {
          title: 'Блог',
          link: 'https://selectel.ru/blog/',
          external: true
        },
        {
          title: 'База знаний',
          link: 'https://kb.selectel.ru/',
          external: true
        },

        {
          title: 'Документация API',
          link: 'https://developers.selectel.ru/',
          external: true
        },
        {
          title: 'Истории успеха',
          link: '/success-story/'
        },
        {
          title: 'Полезные материалы',
          link: '/wp/'
        }
      ]
    },
    {
      id: 'lawyers',
      title: 'Юристам',
      items: [
        {
          title: 'Способы оплаты',
          link: '/about/payments/individuals-pay/'
        },
        {
          title: 'Документы',
          link: '/about/documents/'
        },
        {
          title: 'Реквизиты и лицензии',
          link: '/about/details/'
        },
        {
          title: 'Закупки Selectel',
          link: '/tenders/'
        }
      ]
    },
    {
      id: 'company',
      title: 'Компания',
      items: [
        {
          title: 'О компании',
          link: '/about/company/'
        },
        {
          title: 'Дата-центры',
          link: '/about/data-centers/'
        },
        {
          title: 'Конференц-холл',
          link: '/about/conference-hall/'
        },
        {
          title: 'Контакты',
          link: '/about/contacts/'
        },
        {
          title: 'Спецпредложения и акции',
          link: '/promo/'
        },
        {
          title: 'Предложения партнеров',
          link: '/about/partners-offers/'
        },
        {
          title: 'Инвесторам',
          link: '/investors'
        }
      ]
    },
    {
      id: 'news',
      title: 'Новости и события',
      items: [
        {
          title: 'Новости и пресс-релизы',
          link: '/about/newsroom/news/'
        },
        {
          title: 'Пресса о нас',
          link: '/about/newsroom/press/'
        },
        {
          title: 'Материалы для прессы',
          link: '/about/newsroom/materials/'
        }
      ]
    },
    {
      id: 'techpartners',
      title: 'Технологические партнеры',
      items: [
        {
          title: 'Intel',
          link: '/about/partners/intel/'
        },
        {
          title: 'Veeam Software',
          link: '/about/partners/veeam/'
        },
        {
          title: 'VMware',
          link: '/about/partners/vmware/'
        }
      ]
    },
    {
      id: 'offices',
      title: 'Офисы',
      sections: [
        {
          city: 'Москва',
          address: 'ул. Берзарина, д.&nbsp;36, стр.&nbsp;3',
          phone: '+7 (495) 647-79-80',
          formattedPhone: '+74956477980'
        },
        {
          city: 'Санкт-Петербург',
          address: 'ул. Цветочная, д.&nbsp;21, лит.&nbsp;А',
          phone: '+7 (800) 555-06-75',
          formattedPhone: '+78005550675'
        },
        {
          city: 'Киев',
          address: 'пр. Победы, 131, комн.&nbsp;3'
        }
      ]
    }
  ]
}

const mobileMenu = [
  'partners',
  'company',
  'careers',
  'news',
  'resources',
  'techpartners',
  'lawyers',
  'offices'
]

export default {
  name: 'FooterMenu',
  components: {
    FooterSocials,
    FooterContacts,
    FooterMenuBlock
  },
  data() {
    return {
      menu,
      mobileMenu,
      currentYear: new Date().getFullYear()
    }
  },
  computed: {
    menuBlocks() {
      return this.$breakpoints.sSm
        ? this.mobileMenu.map(item => this.menu[this.$i18n.locale].find(block => block.id === item))
        : this.menu[this.$i18n.locale]
    }
  }
}
</script>

<style lang="scss">
.footer__container {
  padding-top: 39px;
  display: grid;
  grid-template-columns: 3fr 2fr 2fr 2fr 3fr;
  grid-gap: 30px 12px;

  & > * {
    min-width: 0;
  }

  @media (max-width: $breakpoint-xxl + 1) {
    grid-gap: 20px 12px;
  }

  @media (max-width: $breakpoint-xl + 1) {
    grid-template-columns: repeat(5, 1fr);
    grid-gap: 20px 17px;
  }

  @media (max-width: 1150px) {
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 25px 17px;
    padding-top: 24px;
  }

  @media (max-width: $breakpoint-lg) {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 30px 5px;
  }

  @media (max-width: $breakpoint-md) {
    margin-left: -10px;
    margin-right: -10px;
    padding-top: 20px;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(11, auto);
    grid-gap: 0;
  }
}

.footer__copyright-container {
  margin-top: 21px;

  @media (max-width: $breakpoint-xxl + 1) {
    margin-top: -9px;
  }

  @media (max-width: 1150px) {
    grid-row-start: 4;
    grid-row-end: 5;
    margin-top: 2px;
    margin-left: 3px;
  }

  @media (max-width: $breakpoint-lg) {
    margin-top: -6px;
  }

  @media (max-width: $breakpoint-md) {
    grid-row-start: auto;
    grid-row-end: auto;
    margin-top: 25px;
    margin-left: 10px;
    margin-bottom: 32px;
  }
}

.footer__contacts {
  grid-row-start: 1;
  grid-row-end: 3;

  @media (max-width: 1150px) {
    grid-row-start: 1;
    grid-row-end: 4;
  }

  @media (max-width: $breakpoint-lg) {
    grid-row-end: 2;
  }

  @media (max-width: $breakpoint-md) {
    grid-row-start: -4;
    grid-row-end: -3;
  }
}

.footer__logo--company {
  grid-column-start: -2;
  grid-column-end: -1;
  margin-top: 10px;
  width: 100%;

  @media (max-width: $breakpoint-xxl + 1) {
    margin-top: -20px;
  }

  @media (max-width: $breakpoint-xl + 1) {
    margin-top: 2px;
  }

  @media (max-width: 1150px) {
    grid-row-start: 4;
    grid-row-end: 5;
    margin-top: 10px;
  }

  @media (max-width: $breakpoint-lg) {
    margin-top: 0;
  }

  @media (max-width: $breakpoint-md) {
    grid-row-start: auto;
    grid-row-end: auto;
    padding: 0 10px;
  }
}

.footer__socials-mobile {
  display: none !important;

  @media (max-width: $breakpoint-lg) {
    display: grid !important;
  }
}

.footer__socials-desktop {
  @media (max-width: $breakpoint-lg) {
    display: none !important;
  }
}

.footer__copyright {
  margin-bottom: 8px;
  display: block;
  font-size: 12px;
  line-height: 16px;
  color: rgba(#FFF, 0.5);
}

.footer__licenses {
  margin-bottom: 0;
  display: block;
  font-size: 12px;
  line-height: 16px;
  color: rgba(#FFF, 0.5);

  a {
    color: rgba(#FFF, 0.5);

    &:hover {
      color: #FFF;
    }
  }
}

.footer__logo {
  margin-right: 8px;
}
</style>